exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button{color:var(--accent-color);font-size:0.9em;display:inline-block;margin-bottom:5px}.loading{color:#848484;font-size:0.9em;display:inline-block;margin-bottom:5px}\n", ""]);

// exports
